export default "__VITE_ASSET__U07Ks3l8__ 120w, __VITE_ASSET__FWbWQufd__ 240w, __VITE_ASSET__XCtL$6Ic__ 480w";